import React from "react";
import { Line } from "@ant-design/plots";
import { formatCurrency } from "../../utils/formatCurrency";

const LineChartPayments = (props) => {
  const config = {
    data: props.data,
    xField: "month",
    yField: "value",
    yAxis: {
      label: {
        formatter: (value) => formatCurrency(value),
      },
    },
    seriesField: "type",
    color: ({ type }) => {
      return type === 'Pago' ? '#44B779' : type === 'Em Aberto' ? '#F2303A' : '#FFFFF';
    },
    legend: {
      layout: "horizontal",
      position: "top-left",
    },
    tooltip: {
      formatter: (datum) => {
        return {
          name: datum.type,
          value: formatCurrency(datum.value),
        };
      },
    },
    animation: false,
    height: 200,
  };

  return <Line {...config} />;
};

export default LineChartPayments;
